export default __webpack_public_path__ + "static/media/PDestroyer.0ad666a7.png";